import React, { PureComponent } from 'react';

import moment from 'moment';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import Select from 'components/forms/Select';
import PropTypes from 'prop-types';


import { DATE_FORMAT } from 'constants/config';
import { MODAL_TYPES } from 'constants/sequenceContact';


class ActionsModal extends PureComponent {
  static propTypes = {
    isModalOpen: PropTypes.bool,
    whichModal: PropTypes.string,
    whichSeqContact: PropTypes.shape({
      id: PropTypes.string,
      loading: PropTypes.bool,
      loaded: PropTypes.bool,
      email: PropTypes.string,
      current_campaign_sequences: PropTypes.arrayOf(PropTypes.shape({
        sequence: PropTypes.number,
        sequence_name: PropTypes.string,
        sequence_launch_date: PropTypes.string,
        sequence_status: PropTypes.bool,
        is_launched: PropTypes.bool,
      })),
    }).isRequired,
    sequenceToMove: PropTypes.shape({
      status: PropTypes.bool,
      launch_date: PropTypes.string,
    }),
    toggleModal: PropTypes.func.isRequired,
    handleChangeSequence: PropTypes.func.isRequired,
    handleModalSuccess: PropTypes.func.isRequired,
    handleLoadSequenceOptions: PropTypes.func.isRequired,
  };

  static defaultProps = {
    sequenceToMove: null,
    isModalOpen: false,
    whichModal: null,
  };

  state = {
    selectValue: null,
  }

  handleChangeSequence = (value) => {
    this.setState({
      selectValue: value,
    }, () => {
      this.props.handleChangeSequence(value);
    });
  }

  render() {
    let isYesButton = true;
    let sequencesNotLaunched = [];
    let sequencesLaunched = [];
    let isButtonDisabled = false;

    if (this.props.isModalOpen && this.props.whichModal === MODAL_TYPES.REMOVE_MODAL) {
      sequencesNotLaunched = this.props.whichSeqContact.current_campaign_sequences
        .filter(seqCont => !seqCont.is_launched);
      sequencesLaunched = this.props.whichSeqContact.current_campaign_sequences
        .filter(seqCont => seqCont.is_launched);
    }

    if (this.props.isModalOpen && this.props.whichModal === MODAL_TYPES.MOVE_MODAL) {
      isButtonDisabled = !this.props.sequenceToMove;
    }

    if (this.props.whichModal === MODAL_TYPES.REMOVE_MODAL && sequencesNotLaunched.length === 0) {
      isYesButton = false;
    }

    return (
      <ConfirmationModal
        open={this.props.isModalOpen}
        onBackdropClick={() => this.props.toggleModal(false)}
        title="Confirm"
        confirmLabel="Yes"
        showConfirm={isYesButton}
        confirmDisabled={isButtonDisabled}
        onConfirmClick={this.props.handleModalSuccess}
        onCancelClick={() => this.props.toggleModal(false)}
      >
        {this.props.whichModal === MODAL_TYPES.DELETE_MODAL && (
          <React.Fragment>
            <span className="volt-modal--stressed">{this.props.whichSeqContact.email}</span> will be&nbsp;
            <span className="volt-modal--red">DELETED</span> from this sequence, are you sure?
          </React.Fragment>
        )}
        {this.props.whichModal === MODAL_TYPES.BLACKLIST_MODAL && (
          <React.Fragment>
            <span className="volt-modal--stressed">{this.props.whichSeqContact.email}</span> will be marked as&nbsp;
            <span className="volt-modal--red">DO NOT CONTACT</span> for this account
            <br />And will not be able to be used on any other campaigns or sequences belonging to account.
            <br /><br /> Do you wish to continue?
          </React.Fragment>
        )}
        {this.props.whichModal === MODAL_TYPES.MARK_AS_FINISHED_MODAL && (
        <React.Fragment>
          <span className="volt-modal--stressed">{this.props.whichSeqContact.email}</span> will be marked as&nbsp;
          <span className="volt-modal--red">FINISHED</span> for this account
          <br />Contact will not be able scheduled or receive any new messages.
          <br /><br /> Do you wish to continue?
        </React.Fragment>
        )}
        {this.props.whichModal === MODAL_TYPES.UNMARK_AS_FINISHED_MODAL && (
        <React.Fragment>
          <span className="volt-modal--stressed">{this.props.whichSeqContact.email}</span> will be unmarked as&nbsp;
          <span className="volt-modal--red">FINISHED</span> for this account
          <br /><br /> Do you wish to continue?
        </React.Fragment>
        )}
        {this.props.whichModal === MODAL_TYPES.REMOVE_MODAL && (
          <React.Fragment>
            {sequencesNotLaunched.length > 0 &&
              <React.Fragment>
                <span className="volt-modal--stressed">{this.props.whichSeqContact.email}</span> will be&nbsp;
                <span className="volt-modal--red">REMOVED</span> from&nbsp;
                <span className="volt-modal--stressed">{sequencesNotLaunched.length}</span>
                {sequencesNotLaunched.length === 1 ? ' sequence' : ' sequences' }
                <br />
                <br />
              </React.Fragment>
            }
            {sequencesLaunched.length > 0 && (
              <React.Fragment>
                <span className="volt-modal--stressed">
                  {this.props.whichSeqContact.email}
                </span> will not be removed from
                <span className="volt-modal--stressed">
                  &nbsp;{sequencesLaunched.map(seqCont => seqCont.sequence_name).join(', ')}&nbsp;
                </span>
                because {sequencesLaunched.length === 1 ? ' sequence has ' : ' sequences have ' }
                already been launched.
              </React.Fragment>
            )}
          </React.Fragment>
        )}
        {this.props.whichModal === MODAL_TYPES.MOVE_MODAL && (
          <React.Fragment>
            <span className="volt-modal--stressed">
              {this.props.whichSeqContact.email}
            </span> will be <span className="volt-modal--red">MOVED</span><br />
            to the below sequence.
          </React.Fragment>
        )}
        {this.props.whichModal === MODAL_TYPES.MOVE_MODAL && (
          <React.Fragment>
            <div className="filter-selector mt-2">
              <Select
                placeholder="Select sequence"
                value={this.state.selectValue}
                onChange={this.handleChangeSequence}
                cacheOptions
                defaultOptions
                loadOptions={this.props.handleLoadSequenceOptions}
              />
            </div>

            {this.props.sequenceToMove && this.props.sequenceToMove.status && (
              <React.Fragment>
                {moment(this.props.sequenceToMove.launch_date).local().isAfter(new Date()) ?
                  <p>
                    Sequence is active and contact will be messaged on&nbsp;
                    {moment(this.props.sequenceToMove.launch_date).local().format(DATE_FORMAT)}
                  </p> :
                  <p>Sequence is active and contact will be messaged now</p>
                }
              </React.Fragment>
            )}
          </React.Fragment>
        )}
      </ConfirmationModal>
    );
  }
}


export default ActionsModal;
